"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.TextButton = void 0;
var react_1 = __importStar(require("react"));
exports.TextButton = (0, react_1.forwardRef)(function (_a, ref) {
    var children = _a.children, onClick = _a.onClick, onFocus = _a.onFocus, onBlur = _a.onBlur, onKeyDown = _a.onKeyDown, className = _a.className, style = _a.style;
    var commonClassName = "focus:outline-none";
    var ClassName = "border-none underline";
    className = className ? className : ClassName;
    className = "".concat(className, " ").concat(commonClassName);
    return (react_1.default.createElement("button", { className: className, style: style, onClick: onClick, onFocus: onFocus, onBlur: onBlur, onKeyDown: onKeyDown, ref: ref }, children));
});
